'use strict';

const toDateString = (value) => {
  var result = new Date(value);
  var dd = result.getDate();
  var mm = result.getMonth() + 1; //January is 0

  var yyyy = result.getFullYear();

  var today = dd + '/' + mm + '/' + yyyy;
  return today;
};

export default class TimesheetsController {
  /*@ngInject*/
  constructor($http, $rootScope, EditPresetsFactory, CreateStudentFactory, CreateTutorFactory, EditTutorFactory, EditStudentFactory, DeputyImportFactory) {
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.students = [];
    this.tutors = [];
    this.timesheets = [];
    this.loaded = false;
    this.EditPresetsFactory = EditPresetsFactory;
    this.EditStudentFactory = EditStudentFactory;
    this.CreateStudentFactory = CreateStudentFactory;
    this.DeputyImportFactory = DeputyImportFactory;
    this.CreateTutorFactory = CreateTutorFactory;
    this.EditTutorFactory = EditTutorFactory;
    this.rateTypes = ['B', '1', '2'];
    this.total = 0;
    this.errors = [];
    this.deputySheets = [];
    this.loadsRequired = 0;
  }

  $onInit() {
    var today = new Date();
    var todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    this.date = new Date(todayDay.setDate(todayDay.getDate() - todayDay.getDay())); 
    this.loadDate();
    this.loadData(true);
  }

  addDays(days) {
    this.deputySheets = [];

    if (this.selected && this.selected.tutorID) {
      this.saveTimesheets(this.timesheets);
    }

    if (typeof days === 'number') {
      this.date = new Date(this.date.getTime() + (days * 86400000));
    }
  }

  loadStudents() {
    this.$http.get('/api/students').then(res => {
      this.students = res.data;
      this.students = this.students.map(student => {
        student.fullName = student.nameFirst + ' ' + student.nameLast;
        return student;
      })
    })
  }

  intLoadPresets() {
    this.$http.get('/api/presets').then(res => {
      this.presets = res.data || [];
    })
  }

  loadTutors() {
    this.$http.get('/api/tutors/active').then(res => {
      this.tutors = res.data.map(tutor => {
        tutor.fullName = tutor.nameFirst + ' ' + tutor.nameLast;
        return tutor;
      })
      this.loaded = true;
    })
  }

  loadDate() {
    var dateString = this.date.toLocaleDateString();
    var month = dateString.split('/')[1];
    var day = dateString.split('/')[0];
    var year = dateString.split('/')[2];
    if (parseInt(month.charAt(0)) === 0){
			month = month.substring(1);
    }
    if (parseInt(day.charAt(0)) === 0){
			day = day.substring(1);
    } 
    this.weekEnding = day + '/' + month + '/' + year;
  }

  loadData(initialLoad, tutorChange, presetChange) {
    console.log('initial load...');

    if (presetChange) {
      return this.intLoadPresets();
    }

    this.loadDate();

    if (tutorChange) {
      this.loadStudents(); 
      this.saveTimesheets(this.timesheets, true);
      this.$http.get('/api/timesheets/tutor-id/' + this.selected.tutorID, {params: {weekEnding: this.weekEnding}}).then(res => {
        console.log(res);
        if (this.deputySheets.length) {
          const specSheets = this.deputySheets.filter(d => d.tutorID === this.selected.tutorID)

          // Remove added sheets from deputy sheets.
          this.deputySheets = [...this.deputySheets.filter(d => d.tutorID !== this.selected.tutorID)]
          let tutorSheets = res.data || []

          if (tutorSheets.length) {
            tutorSheets = tutorSheets.map(t => {
              const addition = specSheets.find(s => s.studentID === t.studentID && t.weekEnding === toDateString(this.date) && s.rateType === t.rateType);

              if (addition) {
                t.hours += addition.hours
                return t
              }

              return t
            })
          }

          return this.timesheets = [...tutorSheets, ...specSheets]
        }
        this.timesheets = res.data; // Wipes timesheets here

      });
      return;
    };

    this.loadStudents();

    this.loadTutors();

    this.intLoadPresets();

    if (this.selected && this.selected.tutorID) {
      this.$http.get('/api/timesheets/tutor-id/' + this.selected.tutorID, {params: {weekEnding: this.weekEnding}}).then(res => {
        this.timesheets = res.data;
      })
    }

    if (initialLoad) {
      this.$http.get('/api/timesheets/is-unprocessed').then(res => {
        if (res.data.unprocessedExist) {
          alert('Unprocessed timesheets exist.');
        }
      })
    }
  }

  filteredTimesheets() {
    if (!this.date || !this.selected) {
      return [];
    }



    const filteredTimesheets = this.timesheets.filter(timesheet => {
      const datesMatch = timesheet.weekEnding === toDateString(this.date);
      const tutorsMatch = timesheet.tutorID === this.selected.tutorID;

      return datesMatch && tutorsMatch;
    })

    this.total = filteredTimesheets.reduce((accumulator, currentValue) => accumulator + +currentValue.hours, 0);

    return filteredTimesheets
  }

  deputyImport() {
    this.DeputyImportFactory().then(data => {
      this.deputySheets = [];
      const sheets = data.data;
      const errors = [];

      sheets.forEach(sheet => {

        if (typeof sheet['Location Code'] !== 'number') {
          return;
        }

        const tutor = this.tutors.find(t => Number(t.crmID) === sheet['Employee Export Code']);

        if (!tutor) {
          return errors.push(`Tutor with the name ${sheet['Employee Name']} and code ${sheet['Employee Export Code']} not found.`)
        }

        const students = this.students.filter(s => Number(s.crmID) === sheet['Location Code'])

        if (students.length === 0) {
          return errors.push(`The student ID ${sheet['Location Code']} was not found in the database (${sheet['Location Name']})`)
        }

        if (students.length > 1) {
          errors.push(`Multiple students found for ${sheet['Location Code']} (${sheet['Location Name']})`)
        }



        var _preset = {
          tutorID: tutor.tutorID,
          weekEnding: toDateString(this.date),
          studentID: students[0].studentID,
          hours: sheet['Total Hours'],
          rateType: 'B',
          requiresSave: true,
        };

        this.$rootScope.changesToBeSaved = true;

        this.deputySheets.push(_preset);
      })

      this.errors = [...new Set(errors)];

      if (this.selected && this.deputySheets.length) {
        let specSheets = this.deputySheets.filter(d => d.tutorID === this.selected.tutorID)
        console.log(specSheets, 'specSheets')

        if (!specSheets.length) {
          return
        }

        // Remove added sheets from deputy sheets.
        this.deputySheets = this.deputySheets.filter(d => d.tutorID !== this.selected.tutorID)
        this.timesheets = this.timesheets || []

        specSheets.forEach(s => {
          const existing = this.timesheets.findIndex(t => (s.studentID === t.studentID) && (t.weekEnding === s.weekEnding) && (s.rateType === t.rateType))

          if (~existing) {
            this.timesheets[existing].hours += s.hours;
          } else {
            this.timesheets.push(s);
          }
        })

      }
    })
  }

  editStudent(studentID) {
    this.EditStudentFactory(studentID);
  }

  editTutor(selectedID) {
    this.EditTutorFactory(selectedID);
  }

  reduceLoadsRequired() {
    this.loadsRequired -= 1;

    if (this.loadsRequired === 0) {
      this.loadData()
    };

  }


  saveTimesheets(timesheets, preventReloadAfter) {

    this.$rootScope.changesToBeSaved = false;

    this.loadsRequired = 0;

    timesheets.forEach(timesheet => {

      if (!timesheet.requiresSave) {
        return;
      }

      if (!timesheet.hours || +timesheet.hours < 0) {
        console.log('alert')
        return alert('Invalid hours.');
      }

      this.loadsRequired += 1;

      //instantly marks the sheet as saved in order
      //to fix bug of doubling timesheets
      timesheet.requiresSave = false;

      if (timesheet._id) {
        this.$http.put('/api/timesheets/' + timesheet._id, timesheet)
          .then(res => {
            if (preventReloadAfter !== true) {
              this.reduceLoadsRequired()
            }
          });
      } else {
        this.$http.post('/api/timesheets', timesheet)
          .then(res => {
            if (preventReloadAfter !== true) {
              this.reduceLoadsRequired()
            }
          });
      }


    })
  }

  openPresets(tutorID) {
    if (!tutorID) {
      return alert('No tutor selected.')
    };

    this.EditPresetsFactory(tutorID).then(res => this.loadData(null, null, true));
  }

  saveNotes() {
    this.$http.put('/api/tutors/' + this.selected._id, this.selected)
  }

  loadPresets() {
    console.log('loading presets...');

    this.selected = this.tutors.find(tutor => tutor._id === this.selected._id);

    const presets = this.presets.filter(preset => this.selected.tutorID === preset.tutorID);

    if (presets.length === 0) {
      return alert('This tutor has no presets.');
    }

    const orderedPresets = presets.sort((a, b) => {
      let aName = this.getStudentName(a.studentID).toUpperCase();
      let bName = this.getStudentName(b.studentID).toUpperCase();

      if (aName < bName) {
        return -1;
      }

      if (aName > bName) {
        return 1;
      }

      return 0;
    })

    orderedPresets.forEach(preset => {
      var _preset = {
        tutorID: this.selected.tutorID,
        weekEnding: toDateString(this.date),
        studentID: preset.studentID,
        hours: preset.hours,
        rateType: preset.rateType,
        requiresSave: true,
      };

      this.$rootScope.changesToBeSaved = true;

      const duplicateIndex = this.timesheets.findIndex(t => t.studentID === preset.studentID && t.weekEnding === toDateString(this.date) && preset.rateType === t.rateType)
      console.log(duplicateIndex)
      if (~duplicateIndex) {
        console.log('reached duplicate index')
        this.timesheets[duplicateIndex].hours += preset.hours;
        this.timesheets[duplicateIndex].requiresSave = true;
      } else {
        this.timesheets.push(_preset);
      }
    })


  }

  getStudentName(studentID) {
    const student = this.students.find(student => student.studentID === studentID);

    if (!student) {
      return 'Inactive Student'
    }
    return `${student.nameFirst} ${student.nameLast}`;
  }

  delete(item) {
    if (item._id) {
      this.$http.delete('/api/timesheets/' + item._id)
    }
    this.timesheets.splice(this.timesheets.indexOf(item), 1)

    if (this.$rootScope.changesToBeSaved) {
      const stillNeedsSave = this.timesheets.some(timesheet => timesheet.requiresSave);

      this.$rootScope.changesToBeSaved = stillNeedsSave;
    }
  }

  createStudent() {
    this.CreateStudentFactory(this.selected.tutorID).then((res) => {

      this.timesheets.push({
        weekEnding: toDateString(this.date),
        rateType: 'B',
        hours: 1,
        tutorID: this.selected.tutorID,
        requiresSave: true,
        studentID: res,
      });
      this.loadStudents();
      this.$rootScope.changesToBeSaved = true;
      this.intLoadPresets();
    });
  }

  createTutor() {
    this.CreateTutorFactory().then(res => this.loadData());
  }

}



// WEBPACK FOOTER //
// ./client/app/timesheets/timesheets.controller.js